import { stateSetters, stateGetters } from '@/store/store-utils'
import { shallowCompare } from '@/utils'
import socketActions from '@/store/modules/games/wheel/socket-actions'

const INITIAL_BETS = () => ({
  1: 0, 3: 0, 5: 0, 10: 0, 20: 0,
})

const defaultState = {
  // round details
  roundId: null,
  open: false,
  outcome: null,
  rollTs: null, // TODO change
  lockTs: null, // TODO implement
  fairness: {},
  // user inputs
  bets: INITIAL_BETS(),
  lastBets: null,
  //
  history: [],
  showWinnings: false,
}

export default {
  name: 'games/wheel',
  namespaced: true,
  state: () => defaultState,
  getters: {
    ...stateGetters(defaultState),
    betsTotal(state) {
      return Object.values(state.bets).reduce((acc, v) => acc + v, 0)
    },
  },
  mutations: {
    ...stateSetters(defaultState),
    addHistoryRound(state, round) {
      // avoid dupe
      if (state.history.find(i => i.id === round.id)) return

      if (state.history.length > 30) {
        state.history.pop()
      }

      state.history.unshift(round)
    },
  },
  actions: {
    async bet({ commit, getters }, bets) {
      const { open, bets: currentBets } = getters

      if (!open) throw new Error('GameClosed')
      if (!Object.values(bets).every(i => i >= 0)) throw new Error('InvalidParams')

      // NOTE idk about this tbh
      if (shallowCompare(bets, currentBets)) return

      const approvedBets = await this.$api.games.wheel.setBets(bets)

      commit('setBets', approvedBets)
    },
    ...socketActions,
  },
}
